import { useEffect, useRef } from 'react';

export function useInputRef(value: string) {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const focusInput = () => {
    inputRef.current?.focus();
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = value;
    }
  }, [value]);

  return {
    inputRef,
    focusInput,
  };
}
